<template>
	<div v-show="!isSplitScreen">
		<div v-show="(sceneList.length > 1 || groupList.length > 1) && isShowSceneBar" class="scene-bar">
			<div class="scene-bar-placeholder"></div>
			<div class="scene-bar-box">
				<div class="scene-bar-fixed">
					<div v-if="groupList.length > 1" ref="sceneHistory" class="scene-item" @click="showHistory">
						<div class="scene-item-box">
							<div class="thumb"></div>
							<div class="time-mask">
								<div class="time-show">
									<div class="title">
										<i class="iconfont icon-time"></i>
										<div class="label v-ml-5">时光机</div>
									</div>
									<div class="current-time v-ellipsis">
										{{ actionGroupName }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div id="scrollBox" class="scene-bar-handle">
					<div class="scene-bar-scroll">
						<div v-for="item in sceneList" :key="item.id" class="scene-item" :class="{ active: item.id == materialId }">
							<div class="scene-item-box" @click="changeScene(item.id)">
								<div class="thumb" :style="{ backgroundImage: `url(${item.thumb})` }"></div>
								<div class="footer">
									<div class="name v-ellipsis">{{ item.name }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="scene-bar-placeholder"></div>
		</div>
		<div v-if="isShowHistory" class="history-popover" :style="{left:popLeft+'px',width:popWidth+'px'}">
			<div v-for="(item,index) in groupList" :key="item.id" class="group-item" :class="{ active: item.id == activeGroupId}" @click="doChangeGroup(item.id)">
				<span>{{ item.remarkTime }}</span> <i v-if="index == 0" class="iconfont icon-flag"></i>
			</div>
		</div>
		<div v-if="isShowHistory" class="history-popover-mask" @click="isShowHistory = false"></div>
	</div>

</template>

<script>
	import {mapState, mapMutations, mapActions} from 'vuex';
	import IScroll from 'iscroll';
	import build from "../build";

	export default {



		data() {
			return {
				worksId: this.$route.query.id,
				myScroll: null,
				isShowHistory: false,
				popLeft: 0,
				popWidth: 106,
			};
		},

		computed: {
			...mapState('preview', ['krp', 'materialId', 'sceneList', "isShowSceneBar", "groupList", "activeGroupId",'isSplitScreen','activeGroupIdCompare','sceneListCompare','isSplitScreen']),
			actionGroupName() {
				let group = this.groupList.find(item => item.id == this.activeGroupId);
				return group ? group.remarkTime : ''
			}
		},


		watch: {
			sceneList(val) {
				if (val.length > 1) {
					this.initThumb();
				}
			}
		},

    inject:['openVr'],

		methods: {
			...mapActions("preview", {
				activeGetWorksDetail: "getWorksDetail",
			}),
			...mapMutations('preview', {
				mutationUpdateActiveGroupId: 'UPDATE_ACTIVE_GROUP_ID',
				mutationUpdateMaterialId: "UPDATE_MATERIAL_ID",
				mutationUpdateSceneList: "UPDATE_SCENE_LIST",
			}),

			initThumb() {
				this.$nextTick(() => {
					this.calculateScroll();
				});
			},

			//加载滚动条
			calculateScroll() {
				if (this.myScroll) {
					console.log(2)
					this.myScroll.refresh();
				} else {
					this.myScroll = new IScroll('#scrollBox', {
						preventDefault: false,
						scrollX: true,
						scrollY: false,
						scrollbars: false,
						mouseWheel: true,
						interactiveScrollbars: true,
						disablePointer: true,
						disableTouch: !this.isMobile,
						disableMouse: this.isMobile,
					});
				}
			},

			changeScene(materialId) {
				this.openVr(materialId)
			},

			showHistory() {
				let bounding = this.$refs.sceneHistory.getBoundingClientRect();
				this.popLeft = (bounding.width - this.popWidth) / 2 + bounding.left;
				this.isShowHistory = true;
			},

			async doChangeGroup(groupId) {
				if (groupId == this.activeGroupId) {
					return
				}
				let oldScene = this.sceneList.find(item => item.id == this.materialId);
				let topId = oldScene.topId || oldScene.id;
				this.mutationUpdateActiveGroupId(groupId);
				let res = await this.activeGetWorksDetail({worksId: this.worksId, groupId});
				let sceneList = res.sceneList.filter(item => item.status == 2);
				let newScene = sceneList.find(item => item.topId == topId || item.id == topId) || sceneList[0];
				let materialId = newScene.id;
				this.mutationUpdateSceneList(sceneList);
				this.mutationUpdateMaterialId(materialId);
				// let flags = 'KEEPIMAGE | KEEPVIEW | KEEPLIMITS | KEEPLOOKAT | KEEP3D | KEEPPLUGINS | KEEPHOTSPOTS';
				let flags = 'KEEPIMAGE';
				let loaddone = `loadscene(scene_${materialId},null,MERGE,OPENBLEND(0.5, 0.0, 0.75, 0.05, linear));`;
				build.loadPano(this.krp, newScene, null, flags, loaddone);
				this.$nextTick(() => {
					this.calculateScroll();
				});
				this.isShowHistory = false;
			},

		},
	};
</script>

<style scoped>
	.scene-bar {
		height: 100px;
		display: flex;
		justify-content: center;
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
	}

	.scene-bar-box {
		max-width: 100%;
		text-align: center;
		display: inline-flex;
	}

	.scene-bar-placeholder {
		flex: 1;
		background: rgba(0, 0, 0, 0.3);
	}

	.scene-bar-fixed {
		display: inline-flex;
		position: relative;
		z-index: 20;
		padding-top: 7px;
		padding-left: 12px;
		background: rgba(0, 0, 0, 0.3);
	}

	.scene-bar-handle {
		text-align: center;
		display: inline-flex;
		flex: 1;
		min-width: 0;
		padding-top: 7px;
		background: rgba(0, 0, 0, 0.3);
	}

	.scene-bar-scroll {
		text-align: center;
		position: relative;
		z-index: 11;
		white-space: nowrap;
		flex: 1;
		display: inline-block;
		padding-left: 12px;
	}

	.scene-item {
		border: 3px solid #fff;
		display: inline-block;
		box-sizing: border-box;
		width: 86px;
		height: 86px;
		margin-right: 12px;
		position: relative;
		cursor: pointer;
		flex-shrink: 0;
	}

	.scene-item-box {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
	}

	.scene-item.active {
		border-color: rgb(240, 156, 45);
	}

	.scene-item:last-child {
		margin-left: 0;
	}

	.scene-item .thumb {
		display: block;
		width: 100%;
		height: 100%;
		transform: translateZ(0);
		background: url(https://vybbasevr.vyb.cn/clock.jpeg) center center no-repeat;
		background-size: cover;
	}

	.scene-item .footer {
		position: absolute;
		height: 20px;
		width: 100%;
		left: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5);
		color: #fff;
		display: flex;
		align-items: center;
		line-height: 1;
		padding: 0 5px;
		box-sizing: border-box;
	}

	.scene-item .name {
		font-size: 12px;
		transform: translateZ(0);
		flex: 1;
		text-align: left;
	}

	.scene-item .time-control {
		font-size: 14px;
		cursor: pointer;
		margin-left: 10px;
	}

	.scene-item .time-mask {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.7);
		color: #fff;
		font-size: 12px;
	}

	.scene-item .time-show {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.scene-item .time-mask .title {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 5px;
	}

	.scene-item .time-mask .iconfont {
		font-size: 14px;
	}

	.group-list .group-item {
		padding: 8px 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		border-bottom: 1px solid #666;
		text-align: center;
		color: #fff;
	}

	.group-list .group-item.active {
		color: #409eff;
	}

	.group-list .group-item:last-child {
		border-bottom: 0;
	}

	.current-time {
		max-width: 100%;
	}

	.history-popover-mask {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 8000;
	}

	.history-popover {
		background: rgba(0, 0, 0, 0.8);
		border: 0;
		left: 2px;
		bottom: 106px;
		position: absolute;
		padding: 10px 13px 10px 7px;
		box-sizing: border-box;
		border-radius: 4px;
		z-index: 8001;
	}

	.history-popover:after {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		bottom: -6px;
		content: "";
		border-left: 6px solid transparent;
		border-right: 6px solid transparent;
		border-top: 6px solid #000;
	}

	.history-popover .group-item {
		color: #fff;
		cursor: pointer;
		height: 36px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-bottom: 1px solid #666;
		font-family: Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
		position: relative;
		font-size: 13px;
	}

	.history-popover .group-item.active {
		color: #409eff;
		cursor: not-allowed;
	}

	.history-popover .group-item.disabled {
		color: #a7a7a7;
		cursor: not-allowed;
	}

	.history-popover .group-item:last-child {
		border-bottom: 0;
	}

	.history-popover .group-item .iconfont {
		position: absolute;
		font-size: 14px;
		top: 50%;
		transform: translateY(-50%);
		color: #fff;
		right: -10px;
	}

	.history-popover .group-item.active .iconfont {
		color: #409eff;
	}
</style>

